import Booking from "../Components/Booking/Booking";
import RecentBlog from "../Components/RecentBlog/RecentBlog";
import InnerBanner from "../Components/InnerBanner/InnerBanner";
import MultiContent from "../Components/MultiContent/MultiContent";
import {Link} from "react-router-dom";

function CourseDate() {
    return (
        <>
            <InnerBanner
                img_url='courseDateBanner.webp'
                heading={['Discover More About ', <br/>, 'Our Course Dates']}
            />
            <MultiContent
                left_img
                tag="Discover"
                topHeading
                heading="Our Course Dates"
                description={[
                    "Stay up-to-date with Skill Bridge course offerings and schedules on our Course Dates page. Discover the latest information on upcoming courses, whether they're online, remote, or onsite. Our course calendar is your gateway to planning your learning journey with us. ",
                    "Browse through our diverse range of DevOps programs, find the courses that align with your career goals, and select dates that fit your schedule. We believe in providing flexibility and accessibility, ensuring that you have the opportunity to acquire the skills and knowledge you need at your convenience. "
                ]}
                descClass='med'
                img_url='program3.webp'
                fullPara={[
                    'Keep an eye on our Course Dates page to stay informed about upcoming opportunities for professional development and growth. We\'re dedicated to helping you succeed in the eve revolving world of technology, and our course schedules are designed with your needs in mind.'
                ]}
            />
            <section className="datesSec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title center">
                                <h2 className="secHeading">
                                    Course Dates
                                </h2>
                                <p>
                                    The application can take up to 2 weeks, so we advise you to apply sooner rather than
                                    later to give yourself plenty of time to work through the entry materials.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row contentRow" data-aos='fade-up'>
                        <div className="col-md-4">
                            <div className="content">
                                <h6>Date</h6>
                                <p><span>Start: </span>30 October 2023</p>
                                <p><span>End: </span>8 March 2024</p>
                                <p>Hybrid/Remote Delivery</p>
                                <p>(Markers will be closed for Christmas break from 18th December to 5th January)</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="content">
                                <h6>Duration</h6>
                                <p>Mon - Fri <br/> (9:00 - 17:00 Full-time)</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="content">
                                <h6>Cost</h6>
                                <p>£8,500 incl VAT</p>
                                <Link to="/apply-now" className="themeBtn">Apply Now</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row contentRow" data-aos='fade-up'>
                        <div className="col-md-4">
                            <div className="content">
                                <h6>Date</h6>
                                <p><span>Start: </span>30 October 2023</p>
                                <p><span>End: </span>8 March 2024</p>
                                <p>Hybrid/Remote Delivery</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="content">
                                <h6>Duration</h6>
                                <p>Mon - Fri <br/> (9:00 - 17:00 Full-time)</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="content">
                                <h6>Cost</h6>
                                <p>£8,500 incl VAT</p>
                                <Link to="/apply-now" className="themeBtn">Apply Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Booking/>
            <RecentBlog/>
        </>
    )
}

export default CourseDate